import { createApiUrl } from './apiConfig';

let currencyCache = null;
let currencyPromise = null;

// Fetch currency information from the backend
export const getCurrencyInfo = async () => {
  // Return cached currency if available
  if (currencyCache) {
    return currencyCache;
  }

  // Return existing promise if one is in progress
  if (currencyPromise) {
    return currencyPromise;
  }

  // Create new promise to fetch currency
  currencyPromise = fetch(createApiUrl('/api/currency'))
    .then(response => response.json())
    .then(data => {
      currencyCache = data;
      return data;
    })
    .catch(error => {
      console.error('Error fetching currency:', error);
      // Return default currency on error
      return {
        currency: 'GBP',
        symbol: '£',
        locale: 'en-GB'
      };
    });

  return currencyPromise;
};

// Format price with currency symbol
export const formatPrice = (price, options = {}) => {
  const { showSymbol = true, decimals = 2 } = options;
  
  if (showSymbol && currencyCache) {
    return `${currencyCache.symbol}${parseFloat(price).toFixed(decimals)}`;
  }
  
  return parseFloat(price).toFixed(decimals);
};

// Get currency symbol
export const getCurrencySymbol = () => {
  return currencyCache?.symbol || '£';
};

// Get currency code
export const getCurrencyCode = () => {
  return currencyCache?.currency || 'GBP';
};

// Clear cache (useful for testing or when user changes locale)
export const clearCurrencyCache = () => {
  currencyCache = null;
  currencyPromise = null;
};
